// Segnala.tsx — segnala l'avversario: sempre a portata di mano, anche durante la partita. v039: chi segnala blocca
// sempre (niente casella): non si gioca e non ci si contatta più; si sblocca dal profilo.
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { MOTIVI_SEGNALAZIONE, segnala, type MotivoSegnalazione } from "../servizi/sfide.ts";
import { NOTA_MAX } from "../../../condiviso/segnalazioni.ts";

export function Segnala({
  codice,
  token,
  onFatto,
  onAnnulla,
  invia,
  nome,
}: {
  /** v028: di chi si parla (nella domanda in alto) */
  nome?: string;
  codice: string;
  token: string;
  /** Dopo la segnalazione si esce sempre (la persona ora è bloccata). */
  onFatto: () => void;
  onAnnulla: () => void;
  /** Partita a 4 (v015): come si manda la segnalazione (al posto della sfida 1v1). */
  invia?: (motivo: MotivoSegnalazione, nota: string) => Promise<void>;
}) {
  const { t } = useTranslation();
  const [motivo, setMotivo] = useState<MotivoSegnalazione | null>(null);
  const [nota, setNota] = useState("");
  const [stato, setStato] = useState<"modulo" | "invio" | "fatto" | "errore">("modulo");

  if (stato === "fatto") {
    return (
      <div className="segnala">
        <p role="status">{t("gioco.segnalazione_inviata")}</p>
        <p className="nota">{t("gioco.segnala_bloccato_fatto", { nome: nome ?? "" })}</p>
        <button type="button" className="pulsante pulsante-primario" onClick={() => onFatto()}>
          {t("gioco.torna_home")}
        </button>
      </div>
    );
  }
  return (
    <form
      className="segnala"
      onSubmit={(e) => {
        e.preventDefault();
        if (!motivo) return;
        setStato("invio");
        (invia ? invia(motivo, nota) : segnala(codice, token, motivo, nota))
          .then(() => setStato("fatto"))
          .catch(() => setStato("errore"));
      }}
    >
      <p className="segnala-avviso">{t("gioco.segnala_avviso", { nome: nome ?? "" })}</p>
      <p className="nota">{t("gioco.segnala_testo_blocca", { nome: nome ?? "" })}</p>
      <fieldset className="gruppo">
        <legend className="etichetta">{t("gioco.segnala_motivo")}</legend>
        {MOTIVI_SEGNALAZIONE.map((m) => (
          <label key={m} className="scelta-riga">
            <input type="radio" name="motivo" required checked={motivo === m} onChange={() => setMotivo(m)} />
            <span>{t(`gioco.motivo_${m}`)}</span>
          </label>
        ))}
      </fieldset>
      <label className="campo-nome">
        <span className="etichetta">{t("gioco.nota")}</span>
        <textarea className="campo" rows={2} maxLength={NOTA_MAX} value={nota} onChange={(e) => setNota(e.target.value)} />
      </label>
      {stato === "errore" && (
        <p className="admin-errore" role="alert">
          {t("gioco.errore_generico")}
        </p>
      )}
      <div className="azioni-riga">
        <button type="button" className="pulsante pulsante-secondario" onClick={onAnnulla}>
          {t("generale.annulla")}
        </button>
        <button type="submit" className="pulsante pulsante-pericolo" disabled={stato === "invio"}>
          {t("gioco.invia_segnalazione")}
        </button>
      </div>
    </form>
  );
}
